import {assert} from 'Asserts';
import StringResolutionManager from 'models/managers/StringResolutionManager';
import {
  InventoryStructuredTable,
  InventoryTableRowMetadata,
} from 'notebook/integrations/samples/InventoryStructuredTableAdapter';
import {
  InventoryTableMetadata,
  InventoryStructuredTableSchemaType,
} from 'notebook/integrations/samples/InventoryTableConstants';
import {resetContainerParentStorableCustomEvalCache} from 'notebook/integrations/samples/transfer-table-columns/ParentStorableCustomEval';
import {
  getDefaultInventoryActionHandlerWithKwargs,
  InventoryAction,
  InventoryActionHandlerArgs,
  makeInventoryShortcutsActionFunction,
} from 'notebook/structured-tables/action-functions/inventoryShortcutsActionFunction';
import {removeQueryResolutionsFromSnapshot} from 'notebook/tables/excess/Resolver';
import {CustomResolutionQueryType} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TableColumnType, TableIndicatorStatus} from 'notebook/tables/TableConstants';
import TableUtil from 'notebook/tables/TableUtil';

export function getForceEnableInventoryShortcuts(
  structuredTable: InventoryStructuredTable,
  tableStatus?: TableIndicatorStatus
): boolean {
  return structuredTable.rows.some((row) => row.cells.some((cell) => !TableUtil.isCellEmpty(cell)));
}

export function notebookTableMoveStorablesActionHandler(
  args: InventoryActionHandlerArgs<unknown, unknown>
): void {
  getDefaultInventoryActionHandlerWithKwargs(InventoryAction.MOVE_STORABLES, {
    shouldAlwaysShowSampleStatusTable: true,
    onSuccess: () => {
      assert(
        args.structuredTable.fileId != null,
        'Inventory Action is being performed outside of the Notebook'
      );

      const storableIds = args.targetRowsAndStorables.flatMap(({targetStorables}) =>
        targetStorables.map(({id}) => id)
      );
      [
        CustomResolutionQueryType.INVENTORY_TABLE_PARENT_STORABLE_FROM_CONTAINER,
        CustomResolutionQueryType.INVENTORY_TABLE_PARENT_STORABLE_FROM_PLATE,
      ].forEach((queryType) => {
        StringResolutionManager.clearStringResolutionReduxCacheByTypeAndId(queryType, storableIds);
      });

      removeQueryResolutionsFromSnapshot(args.structuredTable.fileId, args.structuredTable.provenanceUuid, {
        [args.structuredTable.name]: {type: 'eval-table'},
      });
      resetContainerParentStorableCustomEvalCache();
    },
  })(args);
}

export const notebookTableInventoryShortcutsActionFunction = makeInventoryShortcutsActionFunction<
  InventoryTableMetadata,
  InventoryTableRowMetadata
>(
  {
    [InventoryAction.MOVE_STORABLES]: notebookTableMoveStorablesActionHandler,
  },
  getForceEnableInventoryShortcuts,
  (structuredTable) => [
    InventoryAction.UPDATE_RESTRICTED_SAMPLE_USERS,
    ...(structuredTable.metadata.storableSchemaType === InventoryStructuredTableSchemaType.PLATE
      ? [InventoryAction.RESERVE, InventoryAction.CHECK_IN, InventoryAction.CHECK_OUT]
      : []),
  ],
  [TableColumnType.PARENT_STORABLE]
);
